<mat-form-field>
  <input
    matInput
    (keyup)="applyFilter($event.target.value)"
    placeholder="Filter"
  />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">
        <a
          *ngIf="!isCentralOffice(row.name)"
          [routerLink]="'/profile/school/' + row['systemSchoolId']"
          (click)="setTitle('School Profile')"
        >
          {{ row.name }}
        </a>
        <span *ngIf="isCentralOffice(row.name)">{{ row.name }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sparkline">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last 4 Months</th>
      <td mat-cell *matCellDef="let row">
        <sparkline
          [chartData]="row?.charts?.trend?.chartData"
          [categories]="row?.charts?.trend?.categories"
          [dataPrefix]="row?.dataPrefix"
          [dataSuffix]="row?.dataSuffix"
          [rowInTable]="i"
          [roundTo]="row?.roundTo"
        ></sparkline>
      </td>
    </ng-container>

    <ng-container matColumnDef="current">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Month</th>
      <td mat-cell *matCellDef="let row">
        <span
          class="school-overall-value"
          [tooltip]="overallValueTooltip"
          placement="left"
          container="body"
          >{{ row?.charts?.overall?.chartData[0]?.y }}</span
        >
        <span *ngIf="row.dataSuffix" class="school-overall-value">{{
          row?.dataSuffix
        }}</span>
        <ng-template #overallValueTooltip>
          <overall-value-tooltip
            [definition]="getSchoolOverallTooltipDesc(row)"
            [data]="row?.charts?.overall?.chartData[0]"
            [dataSuffix]="row?.dataSuffix"
          >
          </overall-value-tooltip>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
